import { ModelEntity, UtilsJsonConverterDate, UtilsMisc, UtilsString } from '@pit/core';
import { JsonObject, JsonProperty } from 'json2typescript';
import { IDtoArchive } from '../interfaces/dto.archive.interface';
import { ShipmentDeliveryType, ShipmentProcessState } from '../interfaces/dto.shipment.process.interface';
import { ShipmentDeliveredTo, ShipmentDeliveredToConfirmation } from '../interfaces/dto.shipment.process.recipient.interface';

// @dynamic
@JsonObject('DtoArchive')
export class DtoArchive extends ModelEntity implements IDtoArchive {

    constructor(initValues: Partial<IDtoArchive> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('depotNumber', String, true)
    public depotNumber?: string = null;

    @JsonProperty('deviceId', String, true)
    public deviceId?: string = null;

    @JsonProperty('externalShipmentId', String, true)
    public externalShipmentId?: string = null;

    @JsonProperty('shipmentNumbers', [String], true)
    public shipmentNumbers?: string[] = [];

    @JsonProperty('timestamp', UtilsJsonConverterDate, true)
    public timestamp?: Date = null;

    @JsonProperty('userName', String, true)
    public userName?: string = null;

    @JsonProperty('productTypeCode', String, true)
    public productTypeCode?: string = null;

    @JsonProperty('productTypeDescription', String, true)
    public productTypeDescription?: string = null;

    @JsonProperty('customerNumber', String, true)
    public customerNumber?: string = null;

    @JsonProperty('customerName', String, true)
    public customerName?: string = null;

    @JsonProperty('customerCostCenterCode', String, true)
    public customerCostCenterCode?: string = null;

    @JsonProperty('addresseeCity', String, true)
    public addresseeCity?: string = null;

    @JsonProperty('addresseeZipCode', String, true)
    public addresseeZipCode?: string = null;

    @JsonProperty('addresseeStreet', String, true)
    public addresseeStreet?: string = null;

    @JsonProperty('addresseeHouseNumber', String, true)
    public addresseeHouseNumber?: string = null;

    @JsonProperty('addresseeName1', String, true)
    public addresseeName1?: string = null;

    @JsonProperty('addresseeName2', String, true)
    public addresseeName2?: string = null;

    @JsonProperty('addresseeName3', String, true)
    public addresseeName3?: string = null;

    @JsonProperty('processState', Number, true)
    public processState?: ShipmentProcessState = ShipmentProcessState.InDepot;

    @JsonProperty('deliveredTo', Number, true)
    public deliveredTo?: ShipmentDeliveredTo = ShipmentDeliveredTo.Unknown;

    @JsonProperty('deliveredToConfirmation', Number, true)
    public deliveredToConfirmation?: ShipmentDeliveredToConfirmation = ShipmentDeliveredToConfirmation.NotNecessary;

    @JsonProperty('deliveryAddressName', String, true)
    public deliveryAddressName?: string = null;

    @JsonProperty('deliveryAddressStreet', String, true)
    public deliveryAddressStreet?: string = null;

    @JsonProperty('deliveryAddressHouseNumber', String, true)
    public deliveryAddressHouseNumber?: string = null;

    @JsonProperty('deliveryAddressZipCode', String, true)
    public deliveryAddressZipCode?: string = null;

    @JsonProperty('deliveryAddressCity', String, true)
    public deliveryAddressCity?: string = null;

    @JsonProperty('deliverySignature', String, true)
    public deliverySignature?: string = null;

    @JsonProperty('shipmentPhoto', String, true)
    public shipmentPhoto?: string = null;

    @JsonProperty('deliveryType', Number, true)
    public deliveryType?: ShipmentDeliveryType = ShipmentDeliveryType.None;

    @JsonProperty('returnCode', String, true)
    public returnCode?: string = null;

    @JsonProperty('returnCodeDescription', String, true)
    public returnCodeDescription?: string = null;

    @JsonProperty('latitude', Number, true)
    public latitude?: number = null;

    @JsonProperty('longitude', Number, true)
    public longitude?: number = null;

    public get fullAddressee(): string {
        return UtilsString.stringFormat('{0}, {1}', this.fullAddresseeName, this.fullAddresseAdress);
    }

    public get fullAddresseAdress(): string {
        return UtilsString.stringFormat('{0} {1}, {2} {3}', this.addresseeZipCode, this.addresseeCity, this.addresseeStreet, this.addresseeHouseNumber);
    }

    public get fullAddresseeName(): string {
        let result: string = UtilsString.stringFormat('{0} {1}', this.addresseeName1, this.addresseeName2).trim();
        result = UtilsString.stringFormat('{0} {1}', result, this.addresseeName3);

        return result;
    }

    public get fullDeliveryAddress(): string {
        return UtilsString.stringFormat('{0} {1}, {2} {3}', this.deliveryAddressZipCode, this.deliveryAddressCity, this.deliveryAddressStreet, this.deliveryAddressHouseNumber);
    }


}
